import { render, staticRenderFns } from "./ListOrder.vue?vue&type=template&id=a2fcd5e0&scoped=true&"
import script from "./ListOrder.vue?vue&type=script&lang=ts&"
export * from "./ListOrder.vue?vue&type=script&lang=ts&"
import style0 from "./ListOrder.vue?vue&type=style&index=0&id=a2fcd5e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fcd5e0",
  null
  
)

export default component.exports